module.exports = __webpack_public_path__ + "img/1215-child.bfd6e710.jpg";